
    import { defineComponent } from 'vue'
    import Card from 'primevue/card'
    import ProgressSpinner from 'primevue/progressspinner'

    export default defineComponent({
        name: 'metadata-card',
        components: {
            Card,
            ProgressSpinner
        },
        props: {
            id: {
                type: Number,
                required: false
            }
        },
        data() {
            return {
                importing: false
            }
        },
        methods: {
            confirmImport() {
                this.$confirm.require({
                    message: this.$t('managers.businessModelManager.importConfirm'),
                    header: this.$t('managers.businessModelManager.importMetadata'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => this.importMetadata()
                })
            },
            async importMetadata() {
                this.importing = true
                await this.$http
                    .post(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/metadata/${this.id}/bmExtract/`)
                    .then(() =>
                        this.$store.commit('setInfo', {
                            title: this.$t('common.toast.createTitle'),
                            msg: this.$t('common.toast.success')
                        })
                    )
                    .catch((error) =>
                        this.$store.commit('setError', {
                            title: this.$t('common.error.generic'),
                            msg: error.message
                        })
                    )
                    .finally(() => (this.importing = false))
            }
        }
    })
